"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./PropSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import { Link } from "react-router-dom";

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" },
];

const cards = [
  {
    icon: <img src="/icons/real-estate.png" alt="Digital Banking" />,
    title: "REAL ESTATE MARKETPLACE PLATFORMS",
    desc: "Streamline property listings, connect buyers and sellers seamlessly, and facilitate smooth transactions.",
  },
  {
    icon: <img src="/icons/robot.webp" alt="Payment and Transaction" />,
    title: "SMART BUILDING & AUTOMATION SOLUTIONS",
    desc: "Enhance tenant comfort, improve energy efficiency, and reduce operational costs.",
  },
  {
    icon: <img src="/icons/property.webp" alt="Wealth Management" />,
    title: "PROPERTY MANAGEMENT SOFTWARE",
    desc: "Automate tasks, manage tenants effectively and gain valuable insights into your rental portfolio.",
  },
  {
    icon: <img src="/icons/valuation.webp" alt="Insurtech Innovations" />,
    title: "VALUATION AND ANALYTICS TOOLS",
    desc: "Leverage data-driven insights to make informed investment decisions and optimize pricing strategies.",
  },
];

export default function ProptechSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us",
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar */}
      <div className="proptech-navbar">
        <div className="container">
          <ul>
            {sectionsToHighlight.map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="proptech-section" id="solutions">
        <div className="container">
          <div className="proptech-stats-row" data-aos="fade-up">
            {stats.map((stat, i) => (
              <div className="proptech-stat" key={i}>
                <div className="proptech-stat-value">{stat.value}</div>
                <div className="proptech-stat-label">{stat.label}</div>
              </div>
            ))}
            <BlueSectionDivider />
          </div>

          <div className="proptech-title-group" data-aos="fade-up">
            <div className="proptech-title">DIGITAL SOLUTIONS</div>
            <div className="proptech-title-blue">
              FOR THE DIFFERENT PROPTECH AREAS
            </div>
          </div>

          <div className="proptech-cards-grid">
            {cards.map((card, i) => (
              <div
                className="proptech-card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={100 + i * 100}
              >
                <div className="proptech-card-icon">{card.icon}</div>
                <div className="proptech-card-title">{card.title}</div>
                <div className="proptech-card-desc">{card.desc}</div>
              </div>
            ))}
          </div>

          <div
            className="proptech-cta-row"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <button className="proptech-cta-btn">
              <Link to="/contact">GET STARTED WITH YOUR PROPTECH DIGITAL PRODUCT</Link>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
